import React from 'react';
import numeral from 'numeral';
import { useTranslation } from 'react-i18next';
import { ChartWrapper, LegendKey } from '../styles';
import { PieChart } from 'react-minimal-pie-chart';

export const CreditUtilizationChart = ({ avgCreditUsage, remainingCredit, creditRating }) => {
    const creditAsNumber = numeral(avgCreditUsage).value();
    const remainingCreditAsNumber = numeral(remainingCredit).value();
    const remainingCreditLegend = +(remainingCreditAsNumber * 100) > 0 ? remainingCredit : '0%';
    const { t } = useTranslation();

    const Legend = () => (
        <ul id='legend'>
            <LegendKey color='#5AEE56'>
                <div data-testid="remaining-credit">
                    <span><span className='color'/>{remainingCreditLegend}</span>
                    <span><em>{t('your_analysis.remaining_credit')}</em></span>
                </div>
            </LegendKey>
            <LegendKey color='#FF5959'>
                <div>
                    <span><span className='color'/>{avgCreditUsage}</span>
                    <span><em>{t('your_analysis.active_credit')}</em></span>
                </div>
            </LegendKey>
        </ul>
    );

    return (
        <ChartWrapper>
            <span style={{ marginBottom: '10px', fontSize: '15px' }}>
                {t('your_analysis.your_credit_utilization')}
                <strong>
                    {t(`your_analysis.${creditRating}`)}
                </strong> 
            </span>
            <div>
                <div data-testid="credit-utilization-chart" style={{ height: '72px', width: '72px' }}>
                    <PieChart
                        data={[
                            { value: creditAsNumber, color: '#FF5959' }, 
                            { value: remainingCreditAsNumber > 0 && remainingCreditAsNumber, color: '#5AEE56' }
                        ]}
                        startAngle={360}
                    />
                </div>
                <Legend />
            </div>
        </ChartWrapper>
    );
};

export default CreditUtilizationChart;